import { Component, Input } from '@angular/core';
import { PromotionHeader } from 'src/app/models/promotion-header.model';
import { CrudService } from 'src/app/services/crud.service';
import { environment } from 'src/environments/environment';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Content, PageOrientation } from 'pdfmake/interfaces';
import { PageSize } from 'pdfmake/interfaces';
import { GroupProductService } from '../group-products-service.service';
import { Base64Images } from 'src/app/services/base64-images.service';
import { DateFormatService } from 'src/app/services/date-format.service';
import { ReportStylesService } from 'src/app/services/report-styles.service';
import { ConfigService } from 'src/app/services/config.service';
import { CostServiceService } from 'src/app/services/cost-service.service';
import { LoadingService } from '../report-loading.service';
import { DateService } from 'src/app/services/date.service';
import { FilterComponent } from '../filter/filter.component';
import { DatePipe } from '@angular/common';
import { firstValueFrom } from 'rxjs';

const pdf = pdfMake;
pdf.vfs = pdfFonts.vfs;

@Component({
  selector: 'app-promotion-confirmation',
  templateUrl: './promotion-confirmation.component.html',
  styleUrls: ['./promotion-confirmation.component.css'],
  providers: [DateService, DatePipe],
  imports: [FilterComponent],
  standalone: true
})
export class PromotionConfirmationComponent {
  @Input() name: string;
  @Input() reportComponent: string;
  @Input() selectedFilter: string = '';
  @Input() selectedFilter2: string = '';

  private promoDetailsUrl: string = environment.baseApiUrl + 'promotion-details';
  private apiUrl: string = environment.baseApiUrl;

  data: any[];
  sortedByTypeData: any[];
  headers: PromotionHeader[];
  promotionName: string = '';
  pageNumber: number = 1;
  userDetails: any;
  disclaimer: string = '';
  excludePrice: boolean;
  supplier_name: string = '';
  pagePromotion: string = '';
  promotionIndex: number = 0;
  filtered_by: string = '';
  currentStartDate: string;
  currentEndDate: string;
  groupNameSelected: any = null;

  constructor(
    private crudService: CrudService,
    private dateService: DateService,
    private groupProductService: GroupProductService,
    private dateFormatService: DateFormatService,
    private base64Image: Base64Images,
    private reportStylesService: ReportStylesService,
    private configService: ConfigService,
    private loadingService: LoadingService,
    private costService: CostServiceService
  ) {
    const userDetailsData = localStorage.getItem("userDetails");
    if (userDetailsData) {
      this.userDetails = JSON.parse(userDetailsData || '{}');
    } else {
      this.userDetails = {};
    }
  }

  transformDataForPdfMake(promotions: any[], supplier_name: string): any[] {
    return promotions.flatMap(promotion => {
      let headers: any[];
      let colspan: number;

      if (!this.excludePrice) {
        headers = [
          'Store Position', 'Order Code', 'Product Description', 'Pack Qty',
          'Buying Dates', 'Total Promo Allow', 'NUC', 'Multi Buy', 'Promo Price inc GST', 'Notes'
        ];
        colspan = 10;
      } else {
        headers = [
          'Store Position', 'Order Code', 'Product Description', 'Pack Qty',
          'Buying Dates', 'Total Promo Allow', 'NUC', 'Multi Buy', 'Notes'
        ];
        colspan = 9;
      }

      const styledHeaders = headers.map(header => ({ text: header, style: 'tableHeader' }));

      const supplierRow: any = [
        { colSpan: colspan, text: promotion.promotion, style: 'supplierStyle' },
        ...Array(colspan - 1).fill({ text: '', style: 'supplierStyle' })
      ];

      promotion.products.sort((a: any, b: any) => a.product_name.localeCompare(b.product_name));

      const productRows = promotion.products.map((product: any) => {
        const allowanceTotal = this.costService.calculateAllowanceTotal(product);
        const nuc = this.costService.calculateNewCost(product);
        this.currentStartDate = product.promotion_start;
        this.currentEndDate = product.promotion_end;

        const buyingDates = `${this.dateFormatService.changeDateFormat(product.buying_start)} - ${this.dateFormatService.changeDateFormat(product.buying_end)}`;

        if (!this.excludePrice) {
          return [
            { text: product.store_position_name, style: 'bodyStyle', alignment: 'center' },
            { text: product.product_code, style: 'bodyStyle', alignment: 'center' },
            { text: product.product_name, style: 'bodyStyle' },
            { text: product.carton_quantity, style: 'bodyStyle', alignment: 'center' },
            { text: buyingDates, style: 'bodyStyle', alignment: 'center' },
            { text: allowanceTotal.toFixed(2), style: 'bodyStyle', alignment: 'center' },
            { text: (nuc / product.packs_per_carton).toFixed(2), style: 'bodyStyle', alignment: 'center' },
            { text: product.multi_buy, style: 'bodyStyle', alignment: 'center' },
            { text: Number(product.sell_price).toFixed(2), style: 'bodyStyle', alignment: 'center' },
            { text: product.comment, style: 'bodyStyle' },
          ];
        } else {
          return [
            { text: product.store_position_name, style: 'bodyStyle', alignment: 'center' },
            { text: product.product_code, style: 'bodyStyle', alignment: 'center' },
            { text: product.product_name, style: 'bodyStyle' },
            { text: product.packs_per_carton, style: 'bodyStyle', alignment: 'center' },
            { text: buyingDates, style: 'bodyStyle', alignment: 'center' },
            { text: allowanceTotal.toFixed(2), style: 'bodyStyle', alignment: 'center' },
            { text: (nuc / product.packs_per_carton).toFixed(2), style: 'bodyStyle', alignment: 'center' },
            { text: product.multi_buy, style: 'bodyStyle', alignment: 'center' },
            { text: product.comment, style: 'bodyStyle' },
          ];
        }
      });

      const newTable = [supplierRow, ...productRows];

      const subheader = {
        stack: [
          {
            columns: [
              {
                text: `${this.name}`,
                style: 'header',
                alignment: 'left',
              },
              {
                image: this.base64Image.getBase64Image(this.userDetails.data.location_token),
                width: 150,
                alignment: 'right',
                margin: [0, 0, 0, 0]
              }
            ]
          }
        ]
      };

      const secondHeader = {
        stack: [
          {
            columns: [
              {
                text: `${this.promotionName}`,
                style: 'subheader',
                alignment: 'left',
                margin: [10, 0, 0, 0]
              },
              {
                text: `${supplier_name}`,
              },
              {
                text: `${this.filtered_by}`,
              },
              {
                text: `Promotion Dates: ${this.dateFormatService.changeDateFormat(this.currentStartDate)} - ${this.dateFormatService.changeDateFormat(this.currentEndDate)}`,
                style: 'subheader',
                alignment: 'right',
                margin: [0, 0, 35, 0]
              }
            ]
          }
        ]
      };

      let widths: any;
      if (!this.excludePrice) {
        widths = [60, 40, 'auto', 40, 90, 40, 40, 40, 40, '*'];
      } else {
        widths = [60, 40, 'auto', 40, 90, 40, 40, 40, '*'];
      }

      if (this.promotionIndex < (promotions.length - 1)) {
        this.promotionIndex++;

        const tableContent: Content = {
          table: {
            dontBreakRows: true,
            headerRows: 1,
            widths: widths,
            body: [styledHeaders, ...newTable]
          },
          pageBreak: 'after',
          layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            hLineColor: () => 'white',
            vLineColor: () => 'white',
            fillColor: function (rowIndex: number, node: any, columnIndex: any) {
              return (rowIndex % 2 === 0) ? '#d9f0f1' : null;
            },
          }
        };

        return [subheader, secondHeader, tableContent];
      } else {
        const tableContent: Content = {
          table: {
            dontBreakRows: true,
            headerRows: 1,
            widths: widths,
            body: [styledHeaders, ...newTable]
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: () => 0,
            hLineColor: () => 'white',
            vLineColor: () => 'white',
            fillColor: function (rowIndex: number, node: any, columnIndex: any) {
              return (rowIndex % 2 === 0) ? '#d9f0f1' : null;
            },
          }
        };

        return [subheader, secondHeader, tableContent];
      }
    });
  }

  styleRow(row: any[], style: string): any[] {
    return row.map(cell => {
      if (typeof cell === 'object' && cell !== null) {
        return { ...cell, style: style };
      } else {
        return { text: cell, style: style };
      }
    });
  }

  async getConfigString() {
    try {
      const response = await this.configService.GetConfigByKey('ReportDisclaimer');

      if (response.length > 0 && response[0].config_string) {
        this.disclaimer = "*" + response[0].config_string;
      } else {
        this.disclaimer = '';
      }
    } catch (error) {
      console.error('Failed to get config string:', error);
    }
  }

  private delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private async downloadPdfWithRetry(documentDefinition: any, filename: string, retries: number = 3) {
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        pdfMake.createPdf(documentDefinition).download(filename);
        return;
      } catch (error) {
        console.error(`Attempt ${attempt} to download PDF failed:`, error);
        if (attempt < retries) {
          await this.delay(1000);
        } else {
          console.error('All attempts to download PDF failed.');
        }
      }
    }
  }

  async exportToExcel(e: any) {
    try {
      const response: Blob = await firstValueFrom(
        this.crudService.getExportData(
          `${this.apiUrl}export/promotion-confirmation?promotion_period_id=${e.promotionSelected.value}&buying_group_id=${e.groupSelected.value}&supplier_code=${e.suppliers.value}`,
          {},
          'blob'
        )
      );

      const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const downloadLink = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = `Promotion_${this.promotionName}_${this.supplier_name}.xlsx`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  async pdfCreator(promotions: any[], supplier_name: string) {
    const transformedDataArray = await this.transformDataForPdfMake(promotions, supplier_name);
    const styles: any = this.reportStylesService.getStyles();

    const documentDefinition = {
      content: [...transformedDataArray],
      pageOrientation: 'landscape' as PageOrientation,
      pageSize: 'A4' as PageSize,
      styles: styles,
      border: [false, false, false, false],
      info: {
        title: `Promotion Confirmation ${this.promotionName}`,
      },
      footer: (currentPage: number, pageCount: number) => {
        return {
          stack: [
            {
              columns: [
                {
                  text: `${this.disclaimer}`,
                  style: 'footerDisclaimer',
                  fontSize: 6
                },
                {
                  text: `Promoflo © 2024 OnTap Data Inc. \n
                  Created: ${this.dateService.getCurrentDateTime()} \n
                  Page ${currentPage} of ${pageCount}`,
                  style: 'copyrightFooter',
                  fontSize: 6
                }
              ]
            }
          ]
        };
      }
    };

    const filename = `Promotion_${this.promotionName}_${supplier_name}_${this.groupNameSelected}.pdf`;
    await this.downloadPdfWithRetry(documentDefinition, filename);

    this.promotionIndex = 0;
    this.loadingService.toggleLoading(false);
  }

  async getPromoData(e: any) {
    let promoDataEDLPChecked: any;
    this.disclaimer = e.disclaimer;

    await this.crudService.getData(`${this.apiUrl}promotion-headers?promotion_period_id=${e.promotionSelected.value}&buying_group_id=${e.groupSelected.value}`).subscribe((result: any) => {
      this.promotionName = result[0].promotion_name;
      this.excludePrice = e.excludePrice;
      this.groupNameSelected = e.groupSelectedName;

      const sortedHeaders = result.sort((a: any, b: any) => {
        const descriptionA = a.description || '';
        const descriptionB = b.description || '';
        return descriptionA.localeCompare(descriptionB, 'en', { numeric: true });
      });

      this.headers = sortedHeaders;

      let requestURL = `${this.promoDetailsUrl}?promotion_period_id=${e.promotionSelected.value}&buying_group_id=${e.groupSelected.value}&supplier_code=${e.suppliers.value}&edlp&tc_confirm`;
      if (this.headers[0].edlp === 1) {
        requestURL = `${this.promoDetailsUrl}?promotion_period_id=${e.promotionSelected.value}&buying_group_id=${e.groupSelected.value}&supplier_code=${e.suppliers.value}&tc_confirm`;
      }

      if (!e.suppliers[1]) {
        if (e.suppliers.value != null && e.groupSelected != null) {
          this.filtered_by = e.buyingGroupFiltered.buying_group_name;
          this.crudService.getData(requestURL).subscribe((result: any) => {
            const firstHeaderId = result.data[0].promotion_header_id;
            promoDataEDLPChecked = result.data.map((promoProduct: any) => {
              return {
                ...promoProduct,
                promotion_header_id: promoProduct.edlp === 1 ? firstHeaderId : promoProduct.promotion_header_id
              };
            });

            const data = this.groupProductService.groupByAlphaNumeric(promoDataEDLPChecked, (product: any) => product.description, this.headers);

            const promotionIds = data.map(item => item.promotionId.toString());
            const headersMap = this.headers.reduce((map: any, header) => {
              map[header.id.toString()] = header;
              return map;
            }, {});

            this.headers = promotionIds.map(id => {
              return headersMap[id];
            }).filter(header => header !== undefined);

            this.supplier_name = result.data[0].supplier_name;
            if (e.export === true) {
              this.exportToExcel(e);
            }
            this.pdfCreator(data, result.data[0].supplier_name);
          });
        }
      } else {
        for (const element of e.suppliers) {
          new Promise(resolve => setTimeout(resolve, 600));
          if (e.groupSelected != null) {
            this.filtered_by = e.buyingGroupFiltered.buying_group_name;
            this.crudService.getData(`${this.promoDetailsUrl}?promotion_period_id=${e.promotionSelected.value}&buying_group_id=${e.groupSelected.value}&supplier_code=${element.supplier_code}&edlp&tc_confirm`).subscribe((result: any) => {
              const firstHeaderId = result.data[0].promotion_header_id;
              promoDataEDLPChecked = result.data.map((promoProduct: any) => {
                return {
                  ...promoProduct,
                  promotion_header_id: promoProduct.edlp === 1 ? firstHeaderId : promoProduct.promotion_header_id
                };
              });

              const data = this.groupProductService.groupByAlphaNumeric(promoDataEDLPChecked, (product: any) => product.description, this.headers);

              const promotionIds = data.map(item => item.promotionId.toString());
              const headersMap = this.headers.reduce((map: any, header) => {
                map[header.id.toString()] = header;
                return map;
              }, {});

              this.headers = promotionIds.map(id => {
                return headersMap[id];
              }).filter(header => header !== undefined);

              this.supplier_name = result.data[0].supplier_name;
              if (e.export === true) {
                this.exportToExcel(e);
              }
              this.pdfCreator(data, result.data[0].supplier_name);
            });
          }
        }
      }
    });
  }

  handleSelectedFilter(filter: string, filter2?: string) {
    this.selectedFilter = filter;
    if (filter2) {
      this.selectedFilter2 = filter2;
    }
  }
}
